// NOTE: Both Meteor and NodeJS will consume this import as a regular javascript code.
//       At the same time, WebPack will simply consider it as a text asset, in which case
//       nodeCrypt will be a path to download that asset.
const nodeCrypto = require('./only.meteorOrNode');

const crypto = typeof nodeCrypto === 'string' ? null : nodeCrypto;
module.exports = crypto;
